import { displayPlateFromRegistration } from './vehicleDisplayPlate';

/** From /fleet-intelligence/vehicles/list: the vehicle's GPS device moved to, or came from, another vehicle on the list. */
export interface SamsaraDeviceNote {
  kind: 'moved_to' | 'moved_from';
  registration: string;
  /** First UK day under the new registration (YYYY-MM-DD). */
  since: string;
}

const SHORT_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * "Samsara device moved to HV76 FBZ on 23 Oct", by display reg. Kept apart from
 * the editable Assets rows so a save can never write it back. Stage, 23 Oct
 * 2026: WV69 ZGY's device moved to HV76 FBZ and WV69 ZGY looked like a dead tracker.
 */
export function samsaraDeviceNotesByReg(
  vehicles: Array<{ registration?: string; samsaraDevice?: SamsaraDeviceNote }>,
): Map<string, string> {
  const notes = new Map<string, string>();
  for (const v of vehicles) {
    const d = v.samsaraDevice;
    const reg = displayPlateFromRegistration(String(v.registration ?? '').trim());
    if (!d || !reg) continue;
    const [, m, day] = d.since.split('-');
    const when = `${Number(day)} ${SHORT_MONTHS[Number(m) - 1] ?? ''}`;
    notes.set(reg, d.kind === 'moved_to'
      ? `Samsara device moved to ${d.registration} on ${when}`
      : `Samsara device moved here from ${d.registration} on ${when}`);
  }
  return notes;
}
